module.exports = "\n <zingchart-angular [config]=\"myConfiges\" [height]=\"350\"></zingchart-angular>"